config               = require '../config'
CrudAPI = require './abstract/CrudAPI'

class CredentialsAPI extends CrudAPI

module.exports = new CredentialsAPI(config.urls.credentials)
